(ns ui.view.entry-criteria.sub
  "Signal graph for the entry-criteria modal's local state.

   Mirrors the layering used in `ui.view.entity-creator.sub`: a single root-state
   sub on the namespaced state key, an ident-derived per-instance state sub,
   and downstream subs deriving from those. Each layer is its own re-frame
   subscription so reactions recalculate only when the slice they actually
   depend on changes."
  (:require
   [re-frame.core :as rf]
   [ui.view.entry-criteria.model :as m]))

(rf/reg-sub
 ;; Shouldn't be used directly — ident needed.
 m/root-state
 (fn [db _]
   (get db m/root)))

(rf/reg-sub
 m/state
 (fn [[_ _args]]
   {:root-state (rf/subscribe [m/root-state])})
 (fn [{:keys [root-state]} [_ {:keys [ident]}]]
   (get-in root-state ident)))

(rf/reg-sub
 m/associations-edits
 (fn [[_ args]]
   {:state (rf/subscribe [m/state args])})
 (fn [{:keys [state]} _]
   (get state m/associations-edits-key)))

(rf/reg-sub
 m/association-edits
 (fn [[_ args]]
   {:associations-edits (rf/subscribe [m/associations-edits
                                       (select-keys args [:ident])])})
 (fn [{:keys [associations-edits]} [_ {:keys [association-key]}]]
   (get associations-edits association-key)))
